// extracted by mini-css-extract-plugin
export default {"window":"modal-window_window__ju77+","header":"modal-window_header__grG1+","text":"modal-window_text__0V2C7"};